/*
 * This contains all the text material option
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  noSink: {
    id: 'cwt.translations.noSink',
    defaultMessage: 'No sink',
  },
  steel: {
    id: 'cwt.translations.steel',
    defaultMessage: 'Stainless steel',
  },
  composite: {
    id: 'cwt.translations.composite',
    defaultMessage: 'Composite',
  },
  porcelain: {
    id: 'cwt.translations.porcelain',
    defaultMessage: 'Porcelain',
  },
});
